import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import { useTheme, useMediaQuery } from "@mui/material";
import ImageList from "@mui/material/ImageList";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ImageListItem from "@mui/material/ImageListItem";
import MobileStepper from "@mui/material/MobileStepper";
import Card from "@mui/material/Card";
import { useState } from "react";
import { TextField } from "@mui/material";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PhoneIcon from "@mui/icons-material/Phone";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useNavigate } from "react-router-dom";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

import Navbar from '../components/navbar.jsx';
import BillingMachineCard from '../components/billingMachineCard.jsx';
import { BILLZAPP_BUNDLES } from '../data/billzappPlans';
import './demo.css'

const images = [
  {
    label: "1",
    imgPath: "images/simon-kadula--gkndM1GvSA-unsplash.jpg",
    desc: "Grow your business with SATERI",
  },
  {
    label: "2",
    imgPath: "images/hunters-race-MYbhN8KaaEc-unsplash.jpg",
    desc: "Quick repair and service solutions",
  },
  {
    label: "3",
    imgPath: "images/jason-leung-poI7DelFiVA-unsplash.jpg",
    desc: "Manage your resturant with us",
  },
];
const itemData = [
  {
    img: "images/zip20.jpg",
    title: "Breakfast",
    rows: 2,
    cols: 2,
  },
  {
    img: "images/handy.jpg",
    title: "Burger",
  },
  {
    img: "images/t10.jpg",
    title: "Coffee",
    cols: 2,
  },
  {
    img: "images/t20.png",
    title: "Hats",
    cols: 2,
  },
];
function Copyright() {
  return (
    <Typography variant="body2" color="white">
      {"Copyright © "}
      <Link color="inherit" href="">
        sateriservices.com
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function Demo() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = React.useState(0);
  const [swiperInstance, setSwiperInstance] = React.useState(null);
  const maxSteps = 3;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [password, setPassword] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", type: "" });

  function handleSubmit(event) {
    event.preventDefault();
    console.log(firstName, lastName, email, dateOfBirth, password);
  }

  const handleNext = () => {
    if (swiperInstance) {
      swiperInstance.slideNext();
    }
  };

  const handleBack = () => {
    if (swiperInstance) {
      swiperInstance.slidePrev();
    }
  };

  const handleSlideChange = (swiper) => {
    setActiveStep(swiper.activeIndex);
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('.contactSection');
    if (contactSection) {
      contactSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const handleCallEnquiry = () => {
    setModalContent({
      title: "Call for Enquiry",
      type: "enquiry"
    });
    setModalOpen(true);
  };

  const handleRequestDemo = () => {
    setModalContent({
      title: "Request Demo",
      type: "demo"
    });
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handlePhoneCall = (phoneNumber) => {
    window.open(`tel:${phoneNumber}`, '_self');
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Navbar/>
      <main>
        {/* Hero unit */}
        <Box style={{ maxWidth: "100%", position: "relative" }}>
          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            onSwiper={setSwiperInstance}
            onSlideChange={handleSlideChange}
            style={{ height: "700px" }}
          >
            {images.map((step, index) => (
              <SwiperSlide key={step.label}>
                <Box
                  component="img"
                  sx={{
                    display: "block",
                    width: "100%",
                  }}
                  style={{
                    maxWidth: "100%",
                    height: "700px",
                    objectFit: "cover",
                    opacity: "0.4",
                  }}
                  src={step.imgPath}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div
            
            style={{
              position: "absolute",
              top: "30%",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="heroSection"
          >
            <Button
              size="small"
              onClick={handleBack}
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowRight
                  style={{ color: "#1976d2", fontSize: "50px" }}
                />
              ) : (
                <KeyboardArrowLeft
                  style={{ color: "#1976d2", fontSize: "50px" }}
                />
              )}
            </Button>
            <div>
              <h1
                className="heroSectionHeading"
              >
                {images[activeStep]?.desc}
              </h1>
              <p style={{ marginTop: "0px",fontSize: "20px",
                  fontWeight: "400", }}>
               At Sateri Electronic Services we help businesses to meet their true pontential.
              </p>
              <Button variant="contained">Learn more</Button>
            </div>
            <Button
              size="small"
              onClick={handleNext}
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowLeft
                  style={{ color: "#1976d2", fontSize: "50px" }}
                />
              ) : (
                <KeyboardArrowRight
                  style={{ color: "#1976d2", fontSize: "50px" }}
                />
              )}
            </Button>
          </div>
        </Box>
        <Box
          sx={{
            backgroundImage: "images/jason-leung-poI7DelFiVA-unsplash.jpg",
            pt: 8,
            pb: 6,
          }}
        >
          <div
            className="aboutSeaction"
          >
            <div  className="aboutSeactionContent">
              <Typography
                className="aboutSeactionContentTitle"
                style={{
                  fontSize: "50px",
                  fontWeight: "700",
                  fontFamily: "Roboto,sans-serif",
                }}
                color="text.primary"
                gutterBottom
              >
                Welcome to Sateri Electronic Services
              </Typography>
              <Typography color="text.secondary" paragraph>
                Sateri Electronics Services is a premier provider specializing in POS 
                software development, along with a key focus on sales and services of 
                Trucount billing machines. Our tailored solutions are designed to elevate business 
                operations, offering user-friendly interfaces and robust functionality. With a commitment 
                to excellence, our skilled technicians ensure seamless operation and optimum performance of 
                Trucount billing machines. Choose Sateri Electronics Services for innovative electronic solutions 
                that enhance efficiency and customer experiences in the dynamic business landscape.
              </Typography>
              
            </div>

            <div className="aboutSeactionGrid">
              <Grid container spacing={2}>
                <Grid item xs={6} sm={6} md={4}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                    style={{ height: "150px", width: "150px" }}
                  >
                    <CardContent sx={{ flexGrow: 1 }}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <PointOfSaleIcon
                          style={{ fontSize: "75px" }}
                        ></PointOfSaleIcon>
                      </div>
                      <Typography style={{ textAlign: "center" }}>
                        Billing Machine
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6} sm={6} md={4}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                    style={{ height: "150px", width: "150px" }}
                  >
                    <CardContent sx={{ flexGrow: 1 }}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <CurrencyRupeeIcon
                          style={{ fontSize: "75px" }}
                        ></CurrencyRupeeIcon>
                      </div>
                      <Typography style={{ textAlign: "center" }}>
                        Note Counting Machine
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6} sm={6} md={4}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                    style={{ height: "150px", width: "150px" }}
                  >
                    <CardContent sx={{ flexGrow: 1 }}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <WysiwygIcon style={{ fontSize: "75px" }}></WysiwygIcon>
                      </div>
                      <Typography style={{ textAlign: "center" }}>
                        Softwares
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                    style={{ height: "150px", width: "150px" }}
                  >
                    <CardContent sx={{ flexGrow: 1 }}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <SupportAgentIcon
                          style={{ fontSize: "75px" }}
                        ></SupportAgentIcon>
                      </div>
                      <Typography style={{ textAlign: "center" }}>
                        Support
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                    style={{ height: "150px", width: "150px" }}
                  >
                    <CardContent sx={{ flexGrow: 1 }}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Box
                          component="img"
                          sx={{
                            display: "block",

                            width: "100%",
                          }}
                          style={{
                            width: "60px",
                            height: "60px",
                            margin: "auto",
                            marginTop: "10px",
                            marginBottom: "10px",
                            objectFit: "cover",
                          }}
                          src={"images/slip.png"}
                        />
                      </div>
                      <Typography style={{ textAlign: "center" }}>
                        Paper rolls
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                    style={{ height: "150px", width: "150px" }}
                  >
                    <CardContent sx={{ flexGrow: 1 }}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Box
                          component="img"
                          sx={{
                            display: "block",

                            width: "100%",
                          }}
                          style={{
                            width: "60px",
                            height: "60px",
                            margin: "auto",
                            marginTop: "10px",
                            marginBottom: "10px",
                            objectFit: "cover",
                          }}
                          src={"images/car-battery.png"}
                        />
                      </div>
                      <Typography style={{ textAlign: "center" }}>
                        Inverter
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </div>
          </div>
        </Box>
        
        {/* BillZapp Software Section */}
        <Box
          sx={{
            pt: 8,
            pb: 6,
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          }}
        >
          <Container maxWidth="lg">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "4rem",
                flexWrap: "wrap",
              }}
              className="billzappSection"
            >
              <div style={{ flex: "1", minWidth: "400px" }}>
                <Typography
                  variant="h2"
                  style={{
                    fontSize: "3.5rem",
                    fontWeight: "800",
                    fontFamily: "Roboto,sans-serif",
                    background: "linear-gradient(135deg, #1976d2, #00bcd4)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    marginBottom: "1rem",
                  }}
                  gutterBottom
                >
                  BillZapp
                </Typography>
                <Typography
                  variant="h4"
                  style={{
                    fontSize: "1.8rem",
                    fontWeight: "600",
                    fontFamily: "Roboto,sans-serif",
                    color: "#2c3e50",
                    marginBottom: "1.5rem",
                  }}
                  gutterBottom
                >
                  A Mobile Pocket Application
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    fontSize: "1.1rem",
                    lineHeight: "1.7",
                    color: "#64748b",
                    marginBottom: "2rem",
                  }}
                  paragraph
                >
                  BillZapp is a mobile pocket application designed for restaurants and food service businesses. 
                  This lightweight, portable solution allows you to manage orders, track sales, and handle 
                  billing directly from your smartphone. Perfect for small restaurants, food trucks, and 
                  cafes that need a simple yet powerful mobile billing solution on the go.
                </Typography>
                <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate('/billzapp')}
                  >
                    Learn More
                  </Button>
                  <Button
                    variant="outlined"
                    size="large"
                    onClick={handleRequestDemo}
                  >
                    Request Demo
                  </Button>
                </Stack>
              </div>
              
              <div style={{ flex: "1", minWidth: "500px" }}>
                <Grid container spacing={3}>
                  {/* Mobile Screenshots */}
                  <Grid item xs={12}>

                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 2,
                        flexWrap: 'wrap',
                      }}
                    >
                      <Paper
                        elevation={8}
                        sx={{
                          borderRadius: '10px',
                          overflow: 'hidden',
                          width: '160px',
                          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                          '&:hover': {
                            transform: 'translateY(-8px) scale(1.05)',
                            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
                          }
                        }}
                      >
                        <Box
                          component="img"
                          sx={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                          }}
                          src="images/billzapp/mobile-dashboard.jpg"
                          alt="BillZapp Mobile Dashboard"
                        />
                      </Paper>
                      <Paper
                        elevation={8}
                        sx={{
                          borderRadius: '10px',
                          overflow: 'hidden',
                          width: '160px',
                          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                          '&:hover': {
                            transform: 'translateY(-8px) scale(1.05)',
                            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
                          }
                        }}
                      >
                        <Box
                          component="img"
                          sx={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                          }}
                          src="images/billzapp/mobile-menu.jpg"
                          alt="BillZapp Mobile Menu"
                        />
                      </Paper>
                      <Paper
                        elevation={8}
                        sx={{
                          borderRadius: '10px',
                          overflow: 'hidden',
                          width: '160px',
                          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                          '&:hover': {
                            transform: 'translateY(-8px) scale(1.05)',
                            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
                          }
                        }}
                      >
                        <Box
                          component="img"
                          sx={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                          }}
                          src="images/billzapp/mobile-reports.jpg"
                          alt="BillZapp Mobile Reports"
                        />
                      </Paper>
                    </Box>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Container>
        </Box>
        
        {/* Products Section: the four Pocket Billing Machine With Software bundles, as on /products */}
        <Box
          id="products"
          sx={{ py: { xs: 8, md: 10 }, bgcolor: 'grey.50', scrollMarginTop: '80px' }}
        >
          <Container maxWidth="lg">
            <Box textAlign="center" sx={{ mb: 6 }}>
              <Typography
                variant="h2"
                fontWeight="bold"
                sx={{ mb: 2, fontSize: { xs: '2.2rem', md: '3rem' } }}
              >
                Pocket Billing Machine With Software
              </Typography>
              <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '650px', mx: 'auto' }}>
                Start billing on day one with a BillZapp receipt printer, 2 inch or 3 inch, and a
                year of BillZapp software. Pay for the printer once, then renew the software every year.
              </Typography>
            </Box>
            <Grid container spacing={{ xs: 3, md: 2, lg: 3 }} justifyContent="center">
              {BILLZAPP_BUNDLES.map((bundle) => (
                <Grid item xs={12} sm={6} md={3} key={bundle.slug}>
                  <BillingMachineCard bundle={bundle} />
                </Grid>
              ))}
            </Grid>
            <Box textAlign="center" sx={{ mt: 4 }}>
              <Button variant="text" onClick={() => navigate('/products')}>
                Already have a printer? See software-only plans
              </Button>
            </Box>
          </Container>
        </Box>

        {/* Desktop Software Section */}
        <Box
          sx={{
            pt: 4,
            pb: 4,
            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
          }}
        >
          <Container maxWidth="xl">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                
                flexWrap: "wrap",
              }}
              className="desktopSoftwareSection"
            >
              <div style={{ flex: "0.7", minWidth: "300px", maxWidth: "300px" }}>
                <Typography
                  variant="h2"
                  style={{
                    fontSize: "2.8rem",
                    fontWeight: "800",
                    fontFamily: "Roboto,sans-serif",
                    color: "black",
                    marginBottom: "1rem",
                  }}
                  gutterBottom
                >
                  BillZapp Desktop Software
                </Typography>
                <Typography
                  variant="h4"
                  style={{
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    fontFamily: "Roboto,sans-serif",
                    color: "#2c3e50",
                    marginBottom: "1rem",
                  }}
                  gutterBottom
                >
                  Complete Management System
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    fontSize: "1rem",
                    lineHeight: "1.6",
                    color: "#64748b",
                    marginBottom: "2rem",
                  }}
                  paragraph
                >
                  Comprehensive restaurant management with advanced billing, inventory tracking, and reporting features.
                </Typography>
                <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate('/billzapp')}
                  >
                    Learn More
                  </Button>
                  <Button
                    variant="outlined"
                    size="large"
                    onClick={handleRequestDemo}
                  >
                    Request Demo
                  </Button>
                </Stack>
              </div>
              
              <div style={{ flex: "1.3", minWidth: "700px" }}>
                <Grid container spacing={3}>
                  {/* Desktop Screenshots */}
                  <Grid item xs={12}>
                    <div className="desktop-screenshots-container">
                      <div className="desktop-screenshot-item first-screenshot">
                        <Paper
                          elevation={8}
                          sx={{
                            borderRadius: '10px',
                            overflow: 'hidden',
                            transition: 'transform 0.4s ease, box-shadow 0.4s ease, z-index 0.3s ease',
                            '&:hover': {
                              transform: 'scale(1.08) rotate(0deg) translateY(-10px)',
                              boxShadow: '0 25px 60px rgba(0, 0, 0, 0.3)',
                              zIndex: 15,
                            }
                          }}
                        >
                          <Box
                            component="img"
                            sx={{
                              width: "100%",
                              height: "auto",
                              display: "block",
                            }}
                            src="images/billzapp/desktop-dashboard.jpg"
                            alt="Desktop Restaurant Management Dashboard"
                          />
                        </Paper>
                      </div>
                      <div className="desktop-screenshot-item second-screenshot">
                        <Paper
                          elevation={8}
                          sx={{
                            borderRadius: '10px',
                            overflow: 'hidden',
                            transition: 'transform 0.4s ease, box-shadow 0.4s ease, z-index 0.3s ease',
                            '&:hover': {
                              transform: 'scale(1.08) rotate(0deg) translateY(-10px)',
                              boxShadow: '0 25px 60px rgba(0, 0, 0, 0.3)',
                              zIndex: 15,
                            }
                          }}
                        >
                          <Box
                            component="img"
                            sx={{
                              width: "100%",
                              height: "auto",
                              display: "block",
                            }}
                            src="images/billzapp/desktop-billing.jpg"
                            alt="Desktop Billing System"
                          />
                        </Paper>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Container>
        </Box>

        <Box
          sx={{
            backgroundImage: "images/jason-leung-poI7DelFiVA-unsplash.jpg",
            pt: 8,
            pb: 6,
          }}
        >
          <div
            className="section2"
          >
            <div className="section2ImageGrid">
              <ImageList
                sx={{ height: 450 }}
                cols={2}
                rowHeight={164}
              >
                {itemData.map((item) => (
                  <ImageListItem key={item.img}>
                    <img
                      style={{
                        height: "100px",
                        weight: "160px",
                        margin: "auto",
                      }}
                      src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                      srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                      alt={item.title}
                      loading="lazy"
                    />
                  </ImageListItem>
                ))}
              </ImageList>
              {/* <Box
                component="img"
                sx={{
                  display: "block",

                  width: "100%",
                }}
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "auto",
                  marginTop: "10px",
                  marginBottom: "10px",
                  objectFit: "cover",
                }}
                src={"images/zip20.jpg"}
              /> */}
            </div>
            <div className="bMSeaction">
              <Typography
                style={{
                  fontSize: "50px",
                  fontWeight: "700",
                  fontFamily: "Roboto,sans-serif",
                }}
                color="text.primary"
                gutterBottom
              >
                TROCOUNT - Electronic Cash Register
              </Typography>
              <Typography
                style={{
                  fontSize: "25px",
                  fontWeight: "500",
                  fontFamily: "Roboto,sans-serif",
                }}
                color="text.primary"
                gutterBottom
              >
                Billing Machines for Restautrants, Hotels, Shopping malls and
                more ...
              </Typography>
              <Typography color="text.secondary" paragraph>
                Trucount is an advanced Electronic Cash Register meticulously designed to cater to a diverse 
                range of businesses, making it the ideal choice for retailers, sweet shops, fast-food establishments, restaurants, grocery stores, and more. With its versatile features and user-friendly interface, Trucount streamlines transactions and enhances efficiency for a seamless business experience. Its adaptability and precision make it a reliable tool for managing sales in various retail environments, ensuring accurate and swift transactions. Trucount stands as a trusted solution for businesses seeking a technologically advanced and user-centric Electronic Cash Register.
              </Typography>
              <Stack sx={{ pt: 4 }} direction="row" spacing={2}>
                <Link href="https://sateriservices.com/billingMachines" underline="none">
                  <Button variant="contained">More Deatils</Button>
                </Link>
                
                <Button variant="outlined" onClick={handleCallEnquiry}>Call for enquiry</Button>
              </Stack>
            </div>
          </div>
        </Box>
        <Box
          sx={{
            backgroundImage: "images/jason-leung-poI7DelFiVA-unsplash.jpg",
            pt: 8,
            pb: 6,
          }}
          style={{ paddingTop: "32px" }}
        >
          <Typography
            style={{
              fontSize: "50px",
              fontWeight: "700",
              fontFamily: "Roboto,sans-serif",
              paddingLeft: "50px",
            }}
            color="text.primary"
            gutterBottom
          >
            Our services
          </Typography>
          <br></br>

          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Grid container spacing={8} style={{ width: "90%" }}>
              <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardMedia
                    component="div"
                    sx={{
                      // 16:9
                      pt: "56.25%",
                    }}
                    image="images/Inverter-PNG-Transparent-Image.png"
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="h2"
                      style={{ fontWeight: "400" }}
                    >
                      Inverter
                    </Typography>
                    <Typography color="text.secondary" paragraph>
                      Sateri Electronic Services specializes in the sales and services of inverters. 
                      Our commitment lies in providing top-notch solutions for reliable power backup. 
                      Whether you are looking to purchase a new inverter or require expert servicing, our 
                      skilled technicians ensure optimal performance and longevity of your inverter. Trust 
                      Sateri Electronic Services for unparalleled expertise in meeting your power backup needs.
                    </Typography>
                  </CardContent>
                  <CardActions>
                    
                  
                    <Button variant="contained" onClick={handleCallEnquiry}>Call for enquiry</Button>
                  
                    
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardMedia
                    component="div"
                    sx={{
                      // 16:9
                      pt: "56.25%",
                    }}
                    image="images/PngItem_4284200.png"
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="h2"
                      style={{ fontWeight: "400" }}
                    >
                      Note counting machine
                    </Typography>
                    <Typography color="text.secondary" paragraph>
                      
Sateri Electronic Services is your go-to destination for the sales and services of note counting machines. 
We offer a range of cutting-edge solutions to meet your currency counting needs. Whether you're looking to 
purchase a new note counting machine or need expert servicing for your existing equipment, our dedicated 
technicians ensure precision and efficiency.
                    </Typography>
                  </CardContent>
                  <CardActions>
                  <Link href="https://sateriservices.com/noteCountingMachines" underline="none">
                    <Button variant="contained">More Deatils</Button>
                  </Link>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardMedia
                    component="div"
                    sx={{
                      // 16:9
                      pt: "56.25%",
                    }}
                    image="images/firosnv-photography-e2Dnu5BPhDU-unsplash.jpg"
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="h2"
                      style={{ fontWeight: "400" }}
                    >
                      Software
                    </Typography>
                    <Typography color="text.secondary" paragraph>
                      Sateri Electronic Services excels in developing software that incorporates the latest 
                      technologies, harnesses the power of cloud storage, and prioritizes user-friendly interfaces. 
                      Our software solutions are at the forefront of innovation, leveraging cutting-edge 
                      technologies to provide unparalleled performance. By integrating cloud storage capabilities,
                       we ensure seamless accessibility and data security.
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small">Comming soon..</Button>
                    
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </div>
        </Box>
        <Box
          sx={{
            backgroundImage: "images/jason-leung-poI7DelFiVA-unsplash.jpg",
            pt: 8,
            pb: 6,
          }}
          style={{ backgroundColor: "#f3f6f8" }}
        >
          <div
            className="contactSection"
            style={{
              padding: isMobile ? '0px 20px' : '0px 150px',
            }}
          >
            <div className="contactSection1">
              <Typography
                style={{
                  fontSize: isMobile ? "2rem" : "50px",
                  fontWeight: "700",
                  fontFamily: "Roboto,sans-serif",
                  marginBottom: "5px",
                  textAlign: isMobile ? "center" : "left",
                }}
                color="text.primary"
                gutterBottom
              >
                Contact us
              </Typography>
              <div style={{ 
                display: "flex", 
                flexDirection: isMobile ? "column" : "row",
                gap: isMobile ? "10px" : "25px",
                marginBottom: isMobile ? "1rem" : "0"
              }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <LocalPhoneIcon></LocalPhoneIcon>
                  <Typography
                    color="text.secondary"
                    paragraph
                    style={{ paddingLeft: "10px", margin: 0 }}
                  >
                    +91 - 9822412353
                  </Typography>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <EmailIcon></EmailIcon>
                  <Typography
                    color="text.secondary"
                    paragraph
                    style={{ paddingLeft: "10px", margin: 0 }}
                  >
                    support@sateriservices.com
                  </Typography>
                </div>
              </div>

              <Typography
                style={{
                  fontSize: isMobile ? "1.2rem" : "25px",
                  fontWeight: "500",
                  fontFamily: "Roboto,sans-serif",
                  textAlign: isMobile ? "center" : "left",
                }}
                color="text.primary"
                gutterBottom
              >
                Services locations :
              </Typography>
              <div style={{ 
                display: "flex", 
                flexDirection: isMobile ? "column" : "row",
                gap: isMobile ? "5px" : "0",
                flexWrap: "wrap"
              }}>
                <div style={{ display: "flex", alignItems: "center", width: isMobile ? "100%" : "auto" }}>
                  <LocationOnIcon></LocationOnIcon>
                  <Typography
                    color="text.secondary"
                    paragraph
                    style={{ paddingLeft: "10px", margin: 0 }}
                  >
                    KOLHAPUR
                  </Typography>
                </div>
                <div style={{ display: "flex", alignItems: "center", width: isMobile ? "100%" : "auto" }}>
                  <LocationOnIcon></LocationOnIcon>
                  <Typography
                    color="text.secondary"
                    paragraph
                    style={{ paddingLeft: "10px", margin: 0 }}
                  >
                    PUNE
                  </Typography>
                </div>
                <div style={{ display: "flex", alignItems: "center", width: isMobile ? "100%" : "auto" }}>
                  <LocationOnIcon></LocationOnIcon>
                  <Typography
                    color="text.secondary"
                    paragraph
                    style={{ paddingLeft: "10px", margin: 0 }}
                  >
                    BENGALURU
                  </Typography>
                </div>
                <div style={{ display: "flex", alignItems: "center", width: isMobile ? "100%" : "auto" }}>
                  <LocationOnIcon></LocationOnIcon>
                  <Typography
                    color="text.secondary"
                    paragraph
                    style={{ paddingLeft: "10px", margin: 0 }}
                  >
                    KONKAN
                  </Typography>
                </div>
              </div>
            </div>
            <div className="contactSection2">
              <form onSubmit={handleSubmit} action={<Link to="/login" />}>
                <Stack 
                  spacing={2} 
                  direction={isMobile ? "column" : "row"} 
                  sx={{ marginBottom: 4 }}
                >
                  <TextField
                    type="text"
                    variant="outlined"
                    color="secondary"
                    label="First Name"
                    onChange={(e) => setFirstName(e.target.value)}
                    value={firstName}
                    fullWidth
                    required
                  />
                  <TextField
                    type="text"
                    variant="outlined"
                    color="secondary"
                    label="Last Name"
                    onChange={(e) => setLastName(e.target.value)}
                    value={lastName}
                    fullWidth
                    required
                  />
                </Stack>
                <TextField
                  type="email"
                  variant="outlined"
                  color="secondary"
                  label="Email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  fullWidth
                  required
                  sx={{ mb: 4 }}
                />
                <TextField
                  variant="outlined"
                  color="secondary"
                  label="Message"
                  multiline
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  required
                  fullWidth
                  sx={{ mb: 4 }}
                />

                <Button variant="contained" type="submit">
                  Submit
                </Button>
              </form>
              {/* <Box
                component="img"
                sx={{
                  display: "block",

                  width: "100%",
                }}
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "auto",
                  marginTop: "10px",
                  marginBottom: "10px",
                  objectFit: "cover",
                }}
                src={"images/zip20.jpg"}
              /> */}
            </div>
          </div>
        </Box>
      </main>
      {/* Footer */}
      <Box
        component="footer"
        sx={{ 
          bgcolor: '#191b1d', 
          color: 'white',
          py: 6,
          px: 4
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {/* Company Info */}
            <Grid item xs={12} md={6}>
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{ mb: 2 }}
              >
                Sateri Electronic Services
              </Typography>
              <Typography
                variant="body1"
                color="#cccccc"
                sx={{ mb: 3, lineHeight: 1.6 }}
              >
                Sateri Electronics Services is a premier provider specializing in POS software development,
                along with a key focus on sales and services of Trucount billing machines. 
                Our tailored solutions are designed to elevate business operations, offering user-friendly 
                interfaces and robust functionality.
              </Typography>
              
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <LocationOnIcon sx={{ mr: 1, color: '#cccccc' }} />
                <Typography color="#cccccc">
                  KOLHAPUR
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <PhoneIcon sx={{ mr: 1, color: '#cccccc' }} />
                <Typography color="#cccccc">
                  +91 - 9822412353 / +91 - 8459583479 
                </Typography>
              </Box>
            </Grid>

            {/* Quick Links */}
            <Grid item xs={12} md={3}>
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ mb: 2 }}
              >
                Quick Links
              </Typography>
              <Stack spacing={1}>
                <Link href="/" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                  {'>'} About
                </Link>
                <Link href="/" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                  {'>'} Services
                </Link>
                <Link href="/billingMachines" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                  {'>'} Billing Machines
                </Link>
                <Link href="/noteCountingMachines" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                  {'>'} Note Counting
                </Link>
                <Link href="/billzapp" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                  {'>'} BillZapp
                </Link>
                <Link href="/products" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                  {'>'} Products
                </Link>
                <Link href="/" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                  {'>'} Contact 
                </Link>
              </Stack>
            </Grid>

            {/* Legal Links */}
            <Grid item xs={12} md={3}>
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ mb: 2 }}
              >
                Legal
              </Typography>
              <Stack spacing={1}>
                <Link href="/terms-and-conditions" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                  Terms and Conditions
                </Link>
                <Link href="/privacy-policy" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                  Privacy Policy
                </Link>
              </Stack>
              
              <Box sx={{ mt: 4 }}>
                <Typography variant="body2" color="#cccccc">
                  {"Copyright © "}
                  <Link color="inherit" href="/" underline="none">
                    sateriservices.com
                  </Link>{" "}
                  {new Date().getFullYear()}
                  {"."}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* End footer */}

      {/* Contact Modal */}
      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        aria-labelledby="contact-modal-title"
        aria-describedby="contact-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: isMobile ? '90%' : 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography id="contact-modal-title" variant="h6" component="h2" fontWeight="bold">
              {modalContent.title}
            </Typography>
            <IconButton onClick={handleCloseModal} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          
          <Typography id="contact-modal-description" sx={{ mb: 3 }} color="text.secondary">
            {modalContent.type === 'demo' 
              ? 'Call us to schedule a free demo of our products and services!' 
              : 'We are available 24/7 for your service needs!'}
          </Typography>

          <Stack spacing={2}>
            <Paper 
              elevation={2} 
              sx={{ 
                p: 2, 
                display: 'flex', 
                alignItems: 'center', 
                gap: 2,
                cursor: 'pointer',
                '&:hover': {
                  bgcolor: 'action.hover'
                }
              }}
              onClick={() => handlePhoneCall('+919822412353')}
            >
              <PhoneIcon color="primary" />
              <Box>
                <Typography variant="body1" fontWeight="medium">
                  +91 - 9822412353
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Primary Contact
                </Typography>
              </Box>
            </Paper>

            <Paper 
              elevation={2} 
              sx={{ 
                p: 2, 
                display: 'flex', 
                alignItems: 'center', 
                gap: 2,
                cursor: 'pointer',
                '&:hover': {
                  bgcolor: 'action.hover'
                }
              }}
              onClick={() => handlePhoneCall('+918459583479')}
            >
              <PhoneIcon color="primary" />
              <Box>
                <Typography variant="body1" fontWeight="medium">
                  +91 - 8459583479
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Secondary Contact
                </Typography>
              </Box>
            </Paper>
          </Stack>

          <Box mt={3} display="flex" justifyContent="flex-end">
            <Button onClick={handleCloseModal} variant="outlined">
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </ThemeProvider>
  );
}
